/** @file Moves, scales, fades, hides or locks a reference image (omitted fields keep their value). */
import { z } from 'zod';
import { skeletonParts } from '@pose2d/format/doc/schemaParts/skeleton';
import { defineCommand } from '../defineCommand';
import { entityDraft } from '../_shared/entityDraft';

const fields = skeletonParts.reference.pick({ x: true, y: true, scale: true, opacity: true, visible: true, locked: true });

/** reference.setTransform: merges the given display fields; values equal to the current ones are a no-op (W2-31). */
export const command = defineCommand({
  name: 'reference.setTransform',
  description: 'Change a reference image: value = any of x, y, scale (> 0), opacity (0..1), visible, locked.',
  input: z.object({ target: z.string().min(1), value: fields.partial().strict() }).strict(),
  apply(draft, input, ctx) {
    const reference = entityDraft(draft, 'reference', ctx.resolve('reference', input.target));
    if (Object.entries(input.value).every(([key, v]) => reference[key] === v)) return;
    Object.assign(reference, input.value);
    draft.meta.updatedAt = ctx.now;
  },
});
